<template>
    <div v-if="checklist" ref="container" id="detail-content" class="content scrollbar right" :class="[{ 'hide-scrollbar': ['portrait'].includes($mq) }, $mq]">
        <div class="top-container" :class="{ infoOpened: infoIsOpen }">
            <AppccTopDetail :hasReopen="showButton()" :hasDelete="showButton()" :hasMoreOptions="canDelete()" @infoOpened="infoOpened" @deleteButton="removeRegister()" @reopenButton="reopenReport()" @settingsButton="settingsRegister" @backButton="backToRecordsTable" :userInfo="checklist.employee" :title="checklist.title" :createdAt="checklist.created_date" :completed="checklist.complete_date" :toolType="type" />
        </div>

        <!-- SECTIONS NAV BAR -->
        <div class="sections-navbar" v-if="hasSections" v-show="shouldShowSectionsNavbar">
            <TemplateSections :sections="sections" :doneSectionsIds="doneSectionsIds" :firstNotDoneSectionId="firstNotDoneSectionId" />
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar-section">
            <ProgressBar v-if="checklist" :itemsCompleted="checklist.completed" :itemsTotal="checklist.total" />
        </div>

        <!-- SEARCH BAR -->
        <div class="search-bar-container" v-if="showSearchBar">
            <SearchBar :search="searchValue" :show-qr-icon="canSearchByQrId" @on-search="handleSearch" @on-button-click="handleClearSearch" @on-qr-click="openQrScanner" :placeholder="$t('detail.sections_search.placeholder')" />
        </div>

        <!-- OVERLAY ESCÁNER QR -->
        <div v-if="showQrOverlay" class="qr-scanner-overlay" @click.self="closeQrOverlay">
            <div class="qr-scanner-mask">
                <StreamBarcodeReader v-if="qrScanActive" @decode="onQrDecode" class="qr-scanner-reader" />
            </div>
            <button type="button" class="qr-scanner-close" aria-label="Cerrar escáner" @click.stop="closeQrOverlay">
                <i class="i-andy-close i-andy-m"></i>
            </button>
        </div>

        <!-- DETAIL BOX (items) -->
        <div class="detail-box" :class="detailBoxClasses">
            <div class="exam performing" id="exam" :class="[{ 'hide-scrollbar': ['portrait'].includes($mq) }, { scrollbar: ['landscape', 'desktop'].includes($mq) }]">
                <div class="note-detail">
                    <NoteDetail v-if="notes && notes.length > 0" :notes="notes" />
                </div>

                <div class="message" v-if="!checklist.complete_date">
                    <Message :message="$t('register.draft')" type="warning"></Message>
                </div>

                <SimpleToast v-if="checklist.description" :key="checklist.id" :text="checklist.description" :includeToggleButton="true" type="checklist-description" :parse="true" />

                <div v-if="checklist.recover && !checklist.complete_date" class="get-last-values">
                    <span class="message" @click="recoverValues()">{{ $t('tasks.get_last_values') }}</span>
                </div>

                <template v-if="checklist && checklist.items">
                    <template v-if="showNoResultsEmptyState">
                        <EmptyPage :description="searchNoResultsMessage" />
                    </template>
                    <template v-else>
                        <!-- ITEMS (if sections, sections and items) -->
                        <Answer v-for="answer in checklistItems" @section-toggled="(sectionId, isOpen) => handleShowOrHideSectionItems(sectionId, isOpen)" :class="{ hidden: closedSectionsIds.includes(answer.section_id) }" :doneSectionsIds="doneSectionsIds" :item="answer" :list="checklist" :cId="checklist.id" :aId="answer.item_id" :cType="type" :key="answer.item_id" :showErrors="showErrors" :isRegisterClosed="!!checklist.complete_date" />
                    </template>
                </template>
            </div>
        </div>
    </div>
    <div v-else class="content hide-scrollbar right empty">
        <!-- <div class="message empty">
            {{ getString('register.empty') }}
        </div> -->
        <EmptyPage :buttonText="$t('empty_pages.return_logs')" @buttonAction="back()" buttonClass="back" :type="'error'" :title="$t('assets.overlay.timeout.message')" :description="$t('empty_pages.error_record')"></EmptyPage>
    </div>
</template>

<script>
import EmptyPage from '@/components/layout/EmptyPage'
import Answer from '@/components/domain/tasks/answer'
import UserTag from '@/components/layout/UserTag'
import AppccTopDetail from '@/components/layout/AppccTopDetail'
import TemplateSections from '@/components/layout/TemplateSections'
import Message from '@/components/domain/ui/Message'
import NoteDetail from '../../layout/NoteDetail.vue'
import ProgressBar from '@/components/domain/ui/ProgressBar'
import SearchBar from '@/components/domain/ui/SearchBar'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { FORMAT } from '@/constants'
import { getCustomApply, getFirstCustomRecord, shouldHideItem } from '@/utils/templateCustom'
import nativeBarcodeScanner from '@/mixins/nativeBarcodeScanner'
import SimpleToast from '@/components/layout/SimpleToast'

export default {
    mixins: [nativeBarcodeScanner],
    components: { Answer, UserTag, EmptyPage, AppccTopDetail, Message, TemplateSections, NoteDetail, ProgressBar, SearchBar, StreamBarcodeReader, SimpleToast },
    props: {
        gId: { type: String },
        showErrors: {
            type: Boolean
        },
        permissions: {
            type: Boolean
        }
    },
    data() {
        return {
            collapsedInfo: false,
            type: 3,
            infoIsOpen: false,
            showNonApply: true,
            isRegister: true,
            closedSectionsIds: [],
            searchValue: '',
            searchResult: [],
            timerSearch: null,
            FORMAT: FORMAT
        }
    },
    computed: {
        checklist() {
            const checklist = this.$store.getters['register/getById'](this.gId)

            if (checklist && checklist.status == 0) {
                this.$bar.addAction('save', {
                    callback: () => this.$emit('saveButton')
                })
            }

            if (checklist == undefined) {
                this.$bar.hide()
            }

            return checklist
        },
        sectionsWithVisibleItemIds() {
            const ids = new Set()
            if (!this.checklist || !this.checklist.items || !this.checklist.def) return ids
            const titleTypes = this.checklist.def.item.itemsTitle
            Object.values(this.checklist.items).forEach((item) => {
                if (item.section_id && !shouldHideItem(item) && !titleTypes.includes(Number(item.type))) {
                    ids.add(item.section_id)
                }
            })
            return ids
        },
        sections() {
            if (!this.checklist || !this.checklist.items || !this.checklist.def) return []
            const titleTypes = this.checklist.def.item.itemsTitle

            return Object.values(this.checklist.items).filter((item) => titleTypes.includes(Number(item.type)) && !item.section_id && !shouldHideItem(item) && this.sectionsWithVisibleItemIds.has(item.item_id))
        },
        hasSections() {
            return this.sections && this.sections.length > 1
        },
        hasItemWithEquipmentId() {
            if (!this.checklist || !this.checklist.items) return false
            return Object.values(this.checklist.items).some((item) => {
                const rec = getFirstCustomRecord(item.custom)
                const fromCustom = rec && rec.equipment_id != null && String(rec.equipment_id).trim() !== ''
                const fromItem = item.equipment_id != null && item.equipment_id !== ''
                return fromCustom || fromItem
            })
        },
        canSearchByQrId() {
            const config = this.$store.getters['login/getConfig']
            if (!config || config.CAN_SEARCH_TASKS_BY_QR_ID !== true) return false
            return this.hasItemWithEquipmentId || (this.hasSections && this.sections.length >= 6)
        },
        showSearchBar() {
            if (this.canSearchByQrId) return true
            if (this.hasSections && this.sections.length >= 5) return true
            if (!this.checklist || !this.checklist.items) return false
            return this.hasItemWithEquipmentId
        },
        shouldShowSectionsNavbar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']
            // No mostrar sections navbar mientras es móvil y el usuario escribe en un input de texto
            if (isMobile && isUserTyping) return false
            return this.hasSections
        },
        shouldShowSearchBar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']
            // No mostrar search bar mientras es móvil y el usuario escribe en un input de texto
            if (isMobile && isUserTyping) return false
            return this.showSearchBar
        },
        hasConnection() {
            return fnCheckConnection()
        },
        checklistItems() {
            const allItems = this.searchValue.length > 0 ? this.searchResult : Object.values(this.checklist.items)

            const titleTypes = this.checklist.def && this.checklist.def.item ? this.checklist.def.item.itemsTitle : [FORMAT.TITLE, FORMAT.SUBTITLE]

            return allItems.filter((item) => {
                if (shouldHideItem(item)) return false
                if (titleTypes.includes(Number(item.type))) {
                    return !this.hasSections || this.sectionsWithVisibleItemIds.has(item.item_id)
                }
                return true
            })
        },
        // itemsSorted() {
        //     if (this.checklist.items) {
        //         return Object.values(this.checklist.items).sort((a, b) => {
        //             return a.order - b.order
        //         })
        //     }
        // },
        removeRolesLevel() {
            return this.$store.getters['login/getRemoveRolesLevel']
        },
        roles() {
            return this.$store.getters['employee/getAllRoles']
        },
        emp_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        userRole() {
            var user = this.$store.getters['employee/getEmployee'](this.emp_id)
            if (user && Object.keys(this.roles).length > 0) {
                return this.roles[user.rol]
            }
        },
        user() {
            return this.$store.getters['employee/getEmployee'](this.emp_id)
        },
        notes() {
            return this.$store.getters['register/getNotesById'](this.gId)
        },
        doneSectionsIds() {
            if (!this.checklist.sections) {
                return []
            }

            let doneSectionsIds = []

            const checklistSections = Object.values(this.checklist.sections)

            for (const section of checklistSections) {
                const sectionItemsAndSubitems = Object.values(this.checklist.items).filter((item) => item.section_id === section.section_id)

                const onlyItemsAndVisibleSubitems = sectionItemsAndSubitems.filter((item) => !shouldHideItem(item) && (!item.parent_id || (item.parent_id && item.is_visible)))

                if (onlyItemsAndVisibleSubitems.every((item) => this.isItemCompleted(item))) {
                    doneSectionsIds.push(section.section_id)
                }
            }

            return doneSectionsIds
        },
        firstNotDoneSectionId() {
            if (!this.checklist.sections || !this.doneSectionsIds || this.doneSectionsIds.length === 0) {
                return null
            }

            const visibleSectionIds = new Set(this.sections.map((item) => item.item_id))
            const allSectionsIds = Object.keys(this.checklist.sections).filter((sectionId) => visibleSectionIds.has(sectionId))

            return allSectionsIds.find((sectionId) => !this.doneSectionsIds.includes(sectionId))
        },
        detailBoxClasses() {
            return {
                'with-sections': this.hasSections,
                'sidebar-collapsed': this.collapsedInfo,
                'not-saved': !this.checklist.created_date,
                'opened-info': this.infoIsOpen,
                'with-search-bar': this.showSearchBar
            }
        },
        showNoResultsEmptyState() {
            return this.searchValue.length > 0 && this.searchResult.length === 0
        },
        searchNoResultsMessage() {
            return this.$t('empty_pages.sections_not_found', { searchInput: this.searchValue })
        }
    },
    methods: {
        /**
         * Determina si un item del checklist está completado.
         * Los items tipo LINK y RESOURCE se consideran siempre completados porque no guardan un valor.
         * @param {Object} item - El item del checklist a evaluar
         * @returns {boolean} - true si el item está completado, false en caso contrario
         */
        isItemCompleted(item) {
            return (item.value !== null && item.value !== '') || item.apply == 0 || getCustomApply(item) === 0 || item.type === FORMAT.LINK || item.type === FORMAT.RESOURCE
        },
        normalizeText(text) {
            if (!text) return ''

            return text
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remover diacríticos (tildes)
        },
        handleSearch(event) {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            const value = event && event.target && event.target.value != null ? event.target.value : ''
            if (value) {
                this.timerSearch = setTimeout(() => {
                    this.searchValue = value
                    this.timerSearch = null
                }, 300)
            } else {
                this.searchValue = ''
            }
        },
        handleClearSearch() {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            this.searchValue = ''
        },
        onQrDecode(decoded) {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            if (decoded && String(decoded).trim() !== '') {
                this.searchValue = String(decoded).trim()
                if (this.showQrOverlay) {
                    this.closeQrOverlay()
                }
            }
        },
        handleShowOrHideSectionItems(sectionId, isOpen) {
            if (isOpen) {
                this.closedSectionsIds.push(sectionId)
            } else {
                this.closedSectionsIds = this.closedSectionsIds.filter((id) => id !== sectionId)
            }
        },
        rolesWithWritePermissions() {
            const permissions = this.$store.getters['register/getTemplateById'](this.$route.params.id)
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('w')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        rolesWithManagePermissions() {
            const permissions = this.$store.getters['register/getTemplateById'](this.$route.params.id)
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('x')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        reopenReport() {
            var self = this
            if (!this.permissions) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role_permission', {
                        name: this.user.name,
                        roles: this.rolesWithManagePermissions()
                    })
                })
                return
            }
            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('popup.register.offline_reopen')
                })
                return
            }

            this.$store.dispatch('register/update', { checklist: this.gId, status: 0 })
            this.$bar.reset()

            if (!self.showQrOverlay) {
                self.$bar.addAction('save', {
                    callback: () => self.$emit('saveButton')
                })
            }
        },
        settingsRegister() {
            const self = this
            this.$popup.itemSettings({
                itemSettings: {
                    noApply: {
                        label: self.$t('popup.item_settings.no_apply'),
                        value: self.showNonApply
                    }
                },
                callSave: (settings) => {
                    const itemSettings = settings.itemSettings
                    self.showNonApply = itemSettings.noApply.value
                    self.$popup.close()
                }
            })
        },
        removeRegister() {
            if (!this.permissions) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role_permission', {
                        name: this.user.name,
                        roles: this.rolesWithWritePermissions()
                    })
                })
                return
            }

            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('popup.register.offline_remove')
                })
                return
            }

            const employee_id = this.$store.getters['loginUser/getLocalEmployee']
            const template_id = this.$route.params.id
            var self = this
            this.$popup.delete({
                message: this.$t('register.delete_msg', { register: this.checklist.title }),
                textSave: this.$t('popup.delete.text_save'),
                textCancel: this.$t('popup.delete.text_cancel'),
                callSave: function () {
                    self.$overlay.loading()
                    self.$store
                        .dispatch('register/delete', { check: self.gId, emp: employee_id })
                        .then((response) => {
                            self.$overlay.hide()
                            self.$popup.close()
                            self.$router.push({ name: 'RegisterDetail', params: { id: template_id } }).catch(() => {})
                        })
                        .catch((error) => {
                            logError(error)
                            self.$overlay.hide()
                            self.$popup.close()
                            self.$router.push({ name: 'RegisterDetail', params: { id: template_id } }).catch(() => {})
                        })
                }
            })
        },

        recoverValues() {
            var self = this
            self.$overlay.loading()

            self.$store.dispatch('register/recoverValues', { check: self.gId }).then(function (response) {
                self.$overlay.hide()
                self.$snackbar.info({ message: self.$t('tooltip.done') })
            })
        },

        canDelete() {
            if (this.checklist.config && !this.checklist.config.nRoles) {
                return true
            }

            // REGISTER IS ON DRAFT = TRUE
            if (this.checklist && this.checklist.status == 0) {
                return true
            }
            // IF HAS REMOVEROLESLEVEL CHECK IF USERROLE LEVEL IS
            else if (this.removeRolesLevel) {
                if (this.userRole && parseInt(this.userRole.level) >= parseInt(this.removeRolesLevel)) {
                    return true
                } else return false
            }
            // USER ROLE >= 2 = TRUE
            else if (this.userRole && parseInt(this.userRole.level) >= 2) {
                return true
            }
            // DEFAULT HIDE
            else return false
        },

        infoOpened() {
            this.infoIsOpen = !this.infoIsOpen
        },
        back() {
            this.$router.push({ name: 'Register' })
        },
        backToRecordsTable() {
            const self = this
            // if (!this.hasConnection) {
            //     self.$popup.confirm({
            //         message: self.$t('register.cancel_uncomplete'),
            //         textSave: self.$t('register.cancel_close'),
            //         textCancel: self.$t('register.cancel_complete'),
            //         callCancel: function (popup, store, item) {
            //             if (item == 'button') {
            //                 self.$router.push({
            //                     name: 'RegisterDetail',
            //                     params: { id: self.$route.params.id }
            //                 })
            //             } else {
            //                 popup.callSave(popup, store)
            //             }
            //         }
            //     })
            // } else {
            self.$router.push({
                name: 'RegisterDetail',
                params: { id: self.$route.params.id, noRefresh: true }
            })
            // }
        },
        getString(str) {
            return this.$t(str)
        },
        getStringVariables(str, params) {
            return this.$t(str, params)
        },
        getStringPlural(str, pos) {
            return this.$tc(str, pos)
        },
        getStringVariable(str, pos) {
            return this.$t(str, { s: pos })
        },
        getStringPluralVariable(str, pos, text) {
            return this.$tc(str, pos, { s: text })
        },
        redirectPath(firstResult) {
            log(this.$root.redirectPath(firstResult))
            return this.$root.redirectPath(firstResult)
        },
        showButton() {
            if (this.checklist.config && !this.checklist.config.nRoles) {
                return true
            }
            if (this.checklist && this.checklist.config && Array.isArray(this.checklist.config.nRoles) && this.checklist.config.nRoles.length > 0) {
                let permissions = ''
                this.checklist.config.nRoles.forEach((employee) => {
                    if (employee.roleId === this.user.rol) {
                        permissions += employee.permissions
                    }
                })
                return permissions.includes('rwx') || permissions.includes('rx')
            }
            return false
        }
    },
    filters: {
        moment: function (date, format) {
            return date ? moment(date).format(format) : ''
        }
    },
    mounted() {
        if (this.gId == 'add') {
            this.$overlay.loading()
        }
    },
    beforeRouteLeave() {
        this.closeQrOverlay()
        this.destroyBarcode()
    },
    created() {
        if (localStorage.getItem('showNonApply') != undefined) {
            this.showNonApply = localStorage.getItem('showNonApply') == 'true' ? true : false
        }
    },
    watch: {
        checklist(checklist) {
            if (checklist == undefined) {
                this.$bar.hide()
            }
        },
        'checklist.status': {
            handler(status) {
                if (this.checklist == undefined) return
                if (status == 0 && !this.showQrOverlay) {
                    this.$bar.addAction('save', {
                        callback: () => this.$emit('saveButton')
                    })
                } else if (status != 0) {
                    this.$bar.hideAction('save')
                }
            },
            immediate: true
        },
        showQrOverlay(newValue) {
            if (newValue) {
                this.$bar.hideAction('save')
            } else if (this.checklist && this.checklist.status == 0) {
                this.$bar.addAction('save', {
                    callback: () => this.$emit('saveButton')
                })
            }
        },
        gId(newValue, oldValue) {
            this.$overlay.hide()
        },
        showNonApply(newValue, oldValue) {
            if (newValue !== oldValue) {
                localStorage.setItem('showNonApply', newValue)
                this.$store.commit('checklist/setShowNoApply', newValue)
            }
        },
        searchValue(newValue, oldValue) {
            if (!this.checklist || !this.checklist.items) return
            if (newValue !== oldValue) {
                if (!newValue || newValue.length === 0) {
                    this.searchResult = []
                    return
                }
                const normalizedSearchValue = this.normalizeText(String(this.searchValue).trim())
                const allItems = Object.values(this.checklist.items)
                const idsOfSectionsToShow = []
                const resultIds = new Set()

                // 1) Secciones (type 8) cuyo título coincide
                for (const item of allItems) {
                    if (Number(item.type) === 8 && !item.section_id) {
                        const normalizedTitle = this.normalizeText(item.title || '')
                        if (normalizedTitle.includes(normalizedSearchValue)) {
                            idsOfSectionsToShow.push(item.item_id)
                            resultIds.add(item.item_id)
                        }
                    }
                }
                // 2) Items por equipment_id o título
                for (const item of allItems) {
                    const rec = getFirstCustomRecord(item.custom)
                    const equipmentIdFromCustom = rec && rec.equipment_id != null && String(rec.equipment_id).trim() !== '' ? String(rec.equipment_id).trim() : ''
                    const equipmentIdFromItem = item.equipment_id != null && item.equipment_id !== '' ? String(item.equipment_id).trim() : ''
                    const equipmentIdStr = equipmentIdFromCustom || equipmentIdFromItem
                    const normalizedEquipmentId = equipmentIdStr !== '' ? this.normalizeText(equipmentIdStr) : ''
                    const normalizedTitle = this.normalizeText(item.title || '')
                    const matchEquipment = normalizedEquipmentId !== '' && (normalizedEquipmentId === normalizedSearchValue || normalizedSearchValue.includes(normalizedEquipmentId) || normalizedEquipmentId.includes(normalizedSearchValue))
                    const matchTitle = normalizedTitle !== '' && normalizedTitle.includes(normalizedSearchValue)
                    if (matchEquipment || matchTitle) {
                        resultIds.add(item.item_id)
                        if (item.section_id && !idsOfSectionsToShow.includes(item.section_id)) {
                            idsOfSectionsToShow.push(item.section_id)
                        }
                    }
                }
                // 3) Construir lista: secciones incluidas + items de esas secciones + items por match directo
                const searchResult = allItems.filter((item) => {
                    if (Number(item.type) === 8 && !item.section_id) {
                        // Incluir si la sección entró por título (step 1) o por equipment_id/título (step 2)
                        return idsOfSectionsToShow.includes(item.item_id) || resultIds.has(item.item_id)
                    }
                    if (item.section_id && idsOfSectionsToShow.includes(item.section_id)) {
                        return true
                    }
                    return resultIds.has(item.item_id)
                })
                this.searchResult = searchResult
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#content.register.detail {
    padding: 0px;
    $column-width: 0%;
    $column-max-width: rem(0px);
    $content-width: 100%;

    > .content {
        $top-info: rem(70px);
        $resume-width: rem(100px);
        overflow: hidden !important;
        padding: 8px !important;
        width: calc(#{$content-width}) !important;
        min-width: calc(100% - #{$column-max-width}) !important;

        position: relative;

        --progress-bar-height: 32px;

        @media (min-width: 768px) {
            --progress-bar-height: 52px;
        }

        .search-bar-container {
            width: 100%;
            padding-right: 8px;
            padding-left: 8px;
            padding-bottom: 8px;

            @media (min-width: 768px) {
                padding-bottom: 16px;
            }

            .search-container {
                .search {
                    font-size: 18px !important;
                    font-family: $text;
                    background-size: 18px !important;

                    @media (max-width: 767px) {
                        height: 40px !important;

                        .button {
                            width: 24px;
                            height: 24px;
                            background-size: 24px !important;
                        }
                    }
                }

                .search::placeholder {
                    font-size: 18px !important;
                    font-family: $text;
                }
            }
        }

        .detail-box {
            $sidebar-size: rem(40px);
            $collapse-button: rem(40px);
            $content-padding: rem(0px);
            $detail-bg: $default-bg-color;
            $detail-text-color: $main-dark;

            position: relative;
            padding: 0;
            padding-left: $content-padding;
            width: 100%;
            height: calc(100% - (185px + var(--progress-bar-height)));
            background-color: $detail-bg;
            overflow: hidden;

            .exam {
                @include border-radius($default-border-radius);
                height: 100%;
                overflow: auto;
                // min-height: 100%;

                display: flex;
                flex-direction: column;
                gap: 16px;

                .note-detail {
                    // margin-top: 20px;
                    width: 100%;
                    padding: 0 6px 0 12px;
                    position: relative;
                }

                .get-last-values {
                    text-align: center;

                    .message {
                        @include interaction();
                        @include border-radius($default-border-radius);
                        @include background($color: $main-t80, $image: img('download_primary.svg'), $position: right 12px center, $size: 22px);
                        @include font-size(m);
                        font-family: $text;
                        color: $main-dark;
                        padding: 12px 42px 12px 12px;
                        display: inline-block;

                        @include bgHover($main-t80);

                        .document {
                            margin: 0px !important;
                        }
                    }
                }

                .empty-page-content {
                    .content-message {
                        padding: 16px 24px !important;
                        width: fit-content !important;
                    }

                    .description {
                        padding-top: 0px !important;
                        font-size: 18px !important;
                    }
                }
            }
        }

        .top-container {
            background-color: $default-bg-color;
            width: 100%;
            height: auto;
            min-height: 40px;
            position: relative;
            z-index: 41;
        }

        .sections-navbar {
            width: 100%;
            height: fit-content;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 16px;
            position: relative;
            top: 0;
            z-index: 10;
        }

        .progress-bar-section {
            width: 100%;
            max-width: 100%;
            position: relative;
            top: 0;
            z-index: 10;
        }

        &.desktop {
            .top-container {
                background-color: $default-bg-color;
                width: 100%;
                padding-bottom: 16px;
                max-height: 106px;
            }

            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                height: calc(100% - 120px);

                &.with-sections {
                    height: calc(100% - (155px + var(--progress-bar-height)));

                    &.opened-info {
                        height: calc(100% - (185px + var(--progress-bar-height)));
                    }

                    &.with-search-bar {
                        height: calc(100% - (155px + var(--progress-bar-height) + 61px));
                        // 61px = search bar + padding

                        &.opened-info {
                            height: calc(100% - (185px + var(--progress-bar-height) + 61px));
                            // 61px = search bar + padding
                        }
                    }
                }
                &.with-search-bar:not(.with-sections) {
                    height: calc(100% - (120px + 61px));
                    &.opened-info {
                        height: calc(100% - (135px + var(--progress-bar-height) + 61px));
                    }
                }
                &.opened-info {
                    height: calc(100% - (135px + var(--progress-bar-height)));
                }
            }

            .exam.performing {
                > .message {
                    > .document.plugin.warning.desktop {
                        padding: 0px 4px 5px 0px !important;
                    }
                }
            }
        }

        &.landscape {
            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                height: calc(100% - 115px);

                &.with-sections {
                    height: calc(100% - (160px + var(--progress-bar-height)));

                    &.opened-info {
                        height: calc(100% - (185px + var(--progress-bar-height)));
                    }

                    &.with-search-bar {
                        height: calc(100% - (160px + var(--progress-bar-height) + 61px));
                        // 61px = search bar + padding

                        &.opened-info {
                            height: calc(100% - (185px + var(--progress-bar-height) + 61px));
                            // 61px = search bar + padding
                        }
                    }
                }
                &.with-search-bar:not(.with-sections) {
                    height: calc(100% - (115px + 61px));
                    &.opened-info {
                        height: calc(100% - (130px + var(--progress-bar-height) + 61px));
                    }
                }
                &.opened-info {
                    height: calc(100% - (130px + var(--progress-bar-height)));
                }
            }

            .exam {
                .message {
                    .document.landscape {
                        width: 99% !important;
                    }
                }
            }
        }
    }

    > .column.left {
        $content-space: 6px;
        width: $column-width !important;
        max-width: $column-max-width !important;
    }
}
</style>

<!-- PORTRAIT STYLES -->
<style lang="scss" scoped>
#content.portrait {
    --progress-bar-height: 32px;
    --header-accordion-extra: 0px;

    @media (min-width: 768px) {
        --progress-bar-height: 52px;
    }

    @media (max-width: 600px) {
        --header-accordion-extra: 130px;
    }

    .content.portrait {
        margin-top: 0 !important;

        .sections-navbar,
        .progress-bar-container,
        .search-bar-container {
            padding-right: 0px;
            padding-left: 0px;
        }

        .detail-box {
            background: transparent;
            height: calc(100% - (63px + 52px));
            padding-bottom: 0px;

            .message {
                padding-left: 0px;
            }

            .exam {
                height: calc(100% - 63px);
                overflow: auto;

                .justify-description,
                .check-available {
                    padding: 8px 20px 8px 50px;
                    background-size: 25px;
                    background-position: left 10px center;

                    .message {
                        @include font-size(xs);
                        line-height: 1rem;
                        width: calc(100% - 100px);
                    }

                    .action {
                        width: 100px;
                        @include font-size(xs);
                        line-height: 0.75rem;
                    }
                }

                .check-available {
                    .message {
                        width: 100%;
                        max-width: 100%;
                    }
                }

                .get-last-values {
                    .message {
                        @include font-size(xs);
                        line-height: normal;
                    }
                }
            }

            &.not-saved {
                height: calc(100% - 115px);
                padding-bottom: 0px;
            }

            &.opened-info {
                height: calc(100% - (115px + var(--progress-bar-height) + var(--header-accordion-extra)));
                padding-bottom: 0px;
            }

            &.with-sections {
                height: calc(100% - (112px + var(--progress-bar-height)));
                padding-bottom: 0px;

                &.opened-info {
                    height: calc(100% - (162px + var(--progress-bar-height) + var(--header-accordion-extra)));
                    padding-bottom: 0px;
                }

                &.with-search-bar {
                    height: calc(100% - (112px + var(--progress-bar-height) + 61px));
                    // 61px = search bar + padding

                    &.opened-info {
                        height: calc(100% - (162px + var(--progress-bar-height) + 61px + var(--header-accordion-extra)));

                        // 61px = search bar + padding
                    }
                }
            }
            &.with-search-bar:not(.with-sections) {
                height: calc(100% - (63px + 52px + 61px));
                &.opened-info {
                    height: calc(100% - (115px + var(--progress-bar-height) + 61px + var(--header-accordion-extra)));
                }
            }
        }

        .top-container {
            height: auto;
            max-height: none;
        }
    }
}

.qr-scanner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2147483646;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qr-scanner-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    ::v-deep video {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.qr-scanner-reader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.qr-scanner-close {
    /* Por defecto: fixed + 56px (HEAD). Variante .qr-scanner-close--inset: absolute + 16px (red-team) */
    position: fixed;
    top: 56px;
    right: 16px;

    &--inset {
        position: absolute;
        top: 16px;
    }
    z-index: 2147483647;
    display: inline-flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid var(--color-Neutral-300, #b8b8b8);
    background: var(--color-Neutral-White, #fff);
    cursor: pointer;

    .i-andy-close {
        color: var(--color-Neutral-800, #424242);
    }

    @media (max-width: 768px) {
        top: calc(72px + env(safe-area-inset-top, 0px));
        right: 12px;
        width: 48px;
        height: 48px;
        padding: 10px;
    }
}
</style>
